module.exports = __webpack_public_path__ + "img/cards.7596ee24.png";